import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import fontStyles from '@sp/ui/typography/fontStyles';
import { isWeb } from '@sp/ui/helpers/device';

export const withDefaultTypographyProps = styled.Text`
  ${({ textAlign }) => (textAlign ? `text-align: ${textAlign};` : '')}
  ${(props) => fontStyles(props.fontWeight)};
  color: ${(props) => props.color || props.theme.DEFAULTS.TEXT_COLOR};
  font-style: ${(props) => props.fontStyle};
`;

withDefaultTypographyProps.defaultProps = {
  color: undefined,
  textAlign: 'left',
  selectable: true,
  fontStyle: 'normal',
};

withDefaultTypographyProps.propTypes = {
  color: PropTypes.string,
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  fontWeight: PropTypes.oneOf(['light', 'regular', 'medium', 'semibold', 'bold']),
};

export const withDefaultTypographyInputProps = styled.TextInput`
  ${({ textAlign }) => (textAlign ? `text-align: ${textAlign};` : '')}
  ${(props) => fontStyles(props.fontWeight)};
  ${isWeb ? 'outline-style: none;' : ''}
  color: ${(props) => props.color || props.theme.DEFAULTS.TEXT_COLOR};
`;

withDefaultTypographyProps.propTypes = {
  color: PropTypes.string,
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  fontWeight: PropTypes.oneOf(['light', 'regular', 'medium', 'semibold', 'bold']),
};

withDefaultTypographyInputProps.defaultProps = {
  color: undefined,
  textAlign: 'left',
};
